import NewImg from './NewImg';

export default NewImg;
